module.exports = __webpack_public_path__ + "img/companion.ef6378b8.svg";